// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form = require("../common/Components/Form.bs.js");
let React = require("react");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let UspsStates = require("usps-states");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");
let AutocompleteV5 = require("../autocomplete/AutocompleteV5.bs.js");
let Form__TextInput = require("../common/Components/Form__TextInput.bs.js");
let Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let SettingsPageHeader = require("./SettingsPageHeader.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let ProfilePageAddressInformationForm_agent_graphql = require("../../__generated__/ProfilePageAddressInformationForm_agent_graphql.bs.js");
let ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql = require("../../__generated__/ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.bs.js");

let validators_zip = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let zip = Form__Helpers.noneIfEmpty(param.zip);
    if (zip !== undefined) {
      return {
        TAG: "Ok",
        _0: zip
      };
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators_theState = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let theState = param.theState;
    if (theState !== undefined) {
      return {
        TAG: "Ok",
        _0: theState
      };
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators_city = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let city = Form__Helpers.noneIfEmpty(param.city);
    if (city !== undefined) {
      return {
        TAG: "Ok",
        _0: city
      };
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators_streetAddress = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let streetAddress = Form__Helpers.noneIfEmpty(param.streetAddress);
    if (streetAddress !== undefined) {
      return {
        TAG: "Ok",
        _0: streetAddress
      };
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators = {
  zip: validators_zip,
  theState: validators_theState,
  city: validators_city,
  streetAddress: validators_streetAddress
};

function initialFieldsStatuses(input) {
  return {
    zip: "Pristine",
    theState: "Pristine",
    city: "Pristine",
    streetAddress: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    zip: "Pristine",
    theState: "Pristine",
    city: "Pristine",
    streetAddress: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      zip: "Pristine",
      theState: "Pristine",
      city: "Pristine",
      streetAddress: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.zip;
  let tmp;
  tmp = typeof match !== "object" ? validators.zip.validate(input) : match._0;
  let match$1 = fieldsStatuses.theState;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.theState.validate(input) : match$1._0;
  let match$2 = fieldsStatuses.city;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.city.validate(input) : match$2._0;
  let match$3 = fieldsStatuses.streetAddress;
  let tmp$3;
  tmp$3 = typeof match$3 !== "object" ? validators.streetAddress.validate(input) : match$3._0;
  let zipResult = tmp;
  let zipResult$1;
  if (zipResult.TAG === "Ok") {
    let theStateResult = tmp$1;
    if (theStateResult.TAG === "Ok") {
      let cityResult = tmp$2;
      if (cityResult.TAG === "Ok") {
        let streetAddressResult = tmp$3;
        if (streetAddressResult.TAG === "Ok") {
          return {
            TAG: "Valid",
            output: {
              streetAddress: streetAddressResult._0,
              city: cityResult._0,
              theState: theStateResult._0,
              zip: zipResult._0
            },
            fieldsStatuses: {
              zip: {
                TAG: "Dirty",
                _0: zipResult,
                _1: "Shown"
              },
              theState: {
                TAG: "Dirty",
                _0: theStateResult,
                _1: "Shown"
              },
              city: {
                TAG: "Dirty",
                _0: cityResult,
                _1: "Shown"
              },
              streetAddress: {
                TAG: "Dirty",
                _0: streetAddressResult,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
        }
        zipResult$1 = zipResult;
      } else {
        zipResult$1 = zipResult;
      }
    } else {
      zipResult$1 = zipResult;
    }
  } else {
    zipResult$1 = zipResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      zip: {
        TAG: "Dirty",
        _0: zipResult$1,
        _1: "Shown"
      },
      theState: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      city: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      },
      streetAddress: {
        TAG: "Dirty",
        _0: tmp$3,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurZipField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.zip, validators_zip, status => {
            let init = state.fieldsStatuses;
            return {
              zip: status,
              theState: init.theState,
              city: init.city,
              streetAddress: init.streetAddress
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTheStateField" :
          let result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.theState, validators_theState, status => {
            let init = state.fieldsStatuses;
            return {
              zip: init.zip,
              theState: status,
              city: init.city,
              streetAddress: init.streetAddress
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurCityField" :
          let result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.city, validators_city, status => {
            let init = state.fieldsStatuses;
            return {
              zip: init.zip,
              theState: init.theState,
              city: status,
              streetAddress: init.streetAddress
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurStreetAddressField" :
          let result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.streetAddress, validators_streetAddress, status => {
            let init = state.fieldsStatuses;
            return {
              zip: init.zip,
              theState: init.theState,
              city: init.city,
              streetAddress: status
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateZipField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.zip, state.submissionStatus, validators_zip, status => {
                let init = state.fieldsStatuses;
                return {
                  zip: status,
                  theState: init.theState,
                  city: init.city,
                  streetAddress: init.streetAddress
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTheStateField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.theState, state.submissionStatus, validators_theState, status => {
                let init = state.fieldsStatuses;
                return {
                  zip: init.zip,
                  theState: status,
                  city: init.city,
                  streetAddress: init.streetAddress
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateCityField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.city, state.submissionStatus, validators_city, status => {
                let init = state.fieldsStatuses;
                return {
                  zip: init.zip,
                  theState: init.theState,
                  city: status,
                  streetAddress: init.streetAddress
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateStreetAddressField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.streetAddress, state.submissionStatus, validators_streetAddress, status => {
                let init = state.fieldsStatuses;
                return {
                  zip: init.zip,
                  theState: init.theState,
                  city: init.city,
                  streetAddress: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  zip: "Pristine",
                  theState: "Pristine",
                  city: "Pristine",
                  streetAddress: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  zip: "Pristine",
                  theState: "Pristine",
                  city: "Pristine",
                  streetAddress: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateZip: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateZipField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTheState: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTheStateField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateCity: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateCityField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateStreetAddress: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateStreetAddressField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurZip: () => dispatch("BlurZipField"),
    blurTheState: () => dispatch("BlurTheStateField"),
    blurCity: () => dispatch("BlurCityField"),
    blurStreetAddress: () => dispatch("BlurStreetAddressField"),
    zipResult: Formality.exposeFieldResult(state.fieldsStatuses.zip),
    theStateResult: Formality.exposeFieldResult(state.fieldsStatuses.theState),
    cityResult: Formality.exposeFieldResult(state.fieldsStatuses.city),
    streetAddressResult: Formality.exposeFieldResult(state.fieldsStatuses.streetAddress),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.zip;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.theState;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.city;
      if (typeof tmp$2 === "object") {
        return true;
      }
      let tmp$3 = match.streetAddress;
      return typeof tmp$3 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return x.value.abbr;
}

function make(value) {
  return {
    value: value,
    label: value.name
  };
}

let defaultOptions = UspsStates.data.map(make);

let StateOption = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  make: make,
  defaultOptions: defaultOptions
};

let convertVariables = ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.Internal.convertVariables;

let convertResponse = ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateAgentAddressInfoMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertFragment = ProfilePageAddressInformationForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ProfilePageAddressInformationForm_agent_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ProfilePageAddressInformationForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ProfilePageAddressInformationForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ProfilePageAddressInformationForm_agent_graphql.node, convertFragment, fRef);
}

let AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ProfilePageAddressInformationForm(props) {
  let agent = RescriptRelay_Fragment.useFragment(ProfilePageAddressInformationForm_agent_graphql.node, convertFragment, props.agent);
  let match = use();
  let isUpdatingAgentAddress = match[1];
  let updateAgentAddress = match[0];
  let state = agent.addressInfo.stateAbbr;
  let form = useForm({
    streetAddress: agent.addressInfo.streetAddress,
    city: agent.addressInfo.city,
    theState: state !== undefined ? UspsStates.data.find(v => v.abbr === state) : undefined,
    zip: agent.addressInfo.zip
  }, (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    updateAgentAddress({
      input: {
        city: param.city,
        stateAbbr: param.theState.abbr,
        streetAddress: param.streetAddress,
        zip: param.zip
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let updateAgentAddressInfo = param.updateAgentAddressInfo;
      if (updateAgentAddressInfo !== undefined && updateAgentAddressInfo.__typename === "Agent") {
        return notifyOnSuccess(undefined);
      } else {
        return notifyOnFailure("An error occurred while submitting your data...");
      }
    }, undefined, undefined);
  });
  let match$1 = form.streetAddressResult;
  let tmp;
  tmp = match$1 !== undefined && match$1.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$1._0
    }) : undefined;
  let match$2 = form.cityResult;
  let tmp$1;
  tmp$1 = match$2 !== undefined && match$2.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$2._0
    }) : undefined;
  let match$3 = form.theStateResult;
  let tmp$2;
  tmp$2 = match$3 !== undefined && match$3.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$3._0
    }) : undefined;
  let match$4 = form.zipResult;
  let tmp$3;
  tmp$3 = match$4 !== undefined && match$4.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$4._0
    }) : undefined;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(SettingsPageHeader.SectionHeading.make, {
            title: "Address"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
              status: form.status,
              submissionErrorToString: v => v,
              onSuccessMessage: "Account updated",
              resetForm: form.reset,
              dismissSubmissionResult: form.dismissSubmissionResult
            }),
            className: "empty:hidden"
          })
        ],
        className: "mb-6 flex flex-col gap-4"
      }),
      JsxRuntime.jsxs(Form.Group.make, {
        label: "Street address",
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            type: "text",
            onChange: event => form.updateStreetAddress((v, value) => ({
              streetAddress: value,
              city: v.city,
              theState: v.theState,
              zip: v.zip
            }), event.target.value),
            onBlur: param => form.blurStreetAddress(),
            disabled: isUpdatingAgentAddress,
            status: Stdlib_Option.map(form.streetAddressResult, x => {
              if (x.TAG === "Ok") {
                return "ok";
              } else {
                return "error";
              }
            }),
            value: Stdlib_Option.getOr(form.input.streetAddress, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp
          })
        ]
      }),
      JsxRuntime.jsxs(Form.Group.make, {
        label: "City",
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            type: "text",
            onChange: event => form.updateCity((v, value) => ({
              streetAddress: v.streetAddress,
              city: value,
              theState: v.theState,
              zip: v.zip
            }), event.target.value),
            onBlur: param => form.blurCity(),
            disabled: isUpdatingAgentAddress,
            status: Stdlib_Option.map(form.cityResult, x => {
              if (x.TAG === "Ok") {
                return "ok";
              } else {
                return "error";
              }
            }),
            value: Stdlib_Option.getOr(form.input.city, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp$1
          })
        ]
      }),
      JsxRuntime.jsxs(Form.Group.make, {
        label: "State",
        children: [
          JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
            getOptionLabel: getOptionLabel,
            getOptionValue: getOptionValue,
            isClearable: true,
            onBlur: param => form.blurTheState(),
            onChange: state => form.updateTheState((v, value) => ({
              streetAddress: v.streetAddress,
              city: v.city,
              theState: value,
              zip: v.zip
            }), Stdlib_Option.map(state, v => v.value)),
            options: defaultOptions,
            value: Stdlib_Option.map(form.input.theState, v => ({
              value: v,
              label: v.name
            })),
            status: Stdlib_Option.getOr(Stdlib_Option.map(form.theStateResult, Stdlib_Result.isError), false) ? "Failure" : "Neutral"
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp$2
          })
        ]
      }),
      JsxRuntime.jsxs(Form.Group.make, {
        label: "Zip",
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            type: "text",
            onChange: event => form.updateZip((v, value) => ({
              streetAddress: v.streetAddress,
              city: v.city,
              theState: v.theState,
              zip: value
            }), event.target.value),
            onBlur: param => form.blurZip(),
            disabled: isUpdatingAgentAddress,
            status: Stdlib_Option.map(form.zipResult, x => {
              if (x.TAG === "Ok") {
                return "ok";
              } else {
                return "error";
              }
            }),
            value: Stdlib_Option.getOr(form.input.zip, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp$3
          })
        ]
      }),
      JsxRuntime.jsx(Form.Group.make, {
        children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
          onClick: extra => Form__Helpers.preventDefault(form.submit, extra),
          disabled: !form.valid() || isUpdatingAgentAddress,
          children: "Save"
        })
      })
    ],
    className: "flex flex-col"
  });
}

let make$1 = ProfilePageAddressInformationForm;

exports.FormConfig = FormConfig;
exports.StateOption = StateOption;
exports.UpdateAgentAddressInfoMutation = UpdateAgentAddressInfoMutation;
exports.AgentFragment = AgentFragment;
exports.make = make$1;
/* defaultOptions Not a pure module */
